
const Cargo = {
    motorista: 1
}

export default Cargo;